import React, { useEffect, useState } from "react";
import { ContentContainer } from "../../../components/layout";
import {
	Button,
	Checkbox,
	DateRangePicker,
	IconButton,
	Modal,
	Select,
} from "../../../components/core";
import {
	REWARD_BEHAVIOR_TYPE,
	campaignStatusOptions,
	dateFilters,
	rewardType,
} from "../settings-coins/dropdown-values";
import { Column } from "primereact/column";
import { paginatorTemplate } from "../settings-coins/components/paginatorTemplate";
import { Badge } from "primereact/badge";
import { Card } from "primereact/card";
import { DataTable } from "primereact/datatable";
import { ColumnGroup } from "primereact/columngroup";
import { Row } from "primereact/row";
import { useLazyQuery, useQuery } from "@apollo/client";
import {
	FETCH_ALL_CAMPAIGNS,
	FILTER_BEHAVIORAL_CAMPAIGN_BY_STATUS,
} from "../../../constants/graphql/settings-coin-queries";
import { QUERY_LOCKER_NAME } from "../../../constants/graphql/drop-off-graphql";
import { Dialog } from "primereact/dialog";
import { useSelector } from "react-redux";
import { formatDateToPHTParts } from "../../../features/coin-campaigns/behavioral-campaign/dropdown";
import {
	formatDate,
	formatDateYYYYMMDD,
	formatTime,
} from "../../../algorithms/date";
import PrimereactDateRange from "../../../components/core/date-range-primereact";
import BehavioralCampaignTable from "./campaign-table";

const BehavioralCampaign = () => {
	const operatorId = localStorage.getItem("user")
		? JSON.parse(localStorage.getItem("user")).operator_id
		: "";
	const rewardBehaviorTypeDropdown = REWARD_BEHAVIOR_TYPE;
	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	// local variables
	const [filterButtonClicked, setFilterButtonClicked] = useState(false);
	const [filteredTableData, setFilteredTableData] = useState([]);
	const [isLoading, setIsLoading] = useState(false);
	const [showRedemptionCodeColumn, setShowRedemptionCodeColumn] =
		useState(true);
	const [filteredBehaviorTableData, setFilteredBehaviorTableData] = useState(
		[]
	);
	const [filterVars, setFilterVars] = useState({
		operatorId: operatorId,
		status: "-1",
		lockerId: "-1",
		campaignId: "-1",
		dateFilterOption: "",
		startDate: null,
		endDate: null,
	});
	const [selectedRowData, setSelectedRowData] = useState([]);
	const [showRedemptionDetail, setShowRedemptionDetail] = useState(false);
	const [selectedLockerName, setSelectedLockerame] = useState("-1");
	const [selectedCampaignName, setSelectedCampaignName] = useState("-1");
	const [selectedStatus, setSelectedStatus] = useState(-1);
	const [selectedRedemptionCode, setSelectedRedemptionCode] = useState("");
	const [campaignNameOption, setCampaignNameOptions] = useState([]);
	const [operatorID, setOperatorID] = useState("");
	const [lockerName, setLockerName] = useState([]);
	const [selectedRewardType, setSelectedRewardType] = useState("-1");
	const [selectedDateFilterValue, setSelectedDateFilterValue] = useState("-1");
	const [noResultSearch, setNoResultSearch] = useState(true);
	const [isTableEmpty, setIsTableEmpty] = useState(true);
	const [newNoData, setnewNoData] = useState(false);
	const [behavioralData, setBehavioralData] = useState([]);
	console.log({ isTableEmpty });
	const [redemptionCodeData, setRedemptionCodeData] = useState([]);
	const [customStartDate, setCustomStartDate] = useState(new Date());
	const [customEndDate, setCustomEndDate] = useState(new Date());

	// gql
	const [getAllCampaign, { data, loading }] = useLazyQuery(FETCH_ALL_CAMPAIGNS);

	const allCampaigns = useQuery(FILTER_BEHAVIORAL_CAMPAIGN_BY_STATUS);
	console.log({ allCampaigns });
	const { data: allLockerNames } = useQuery(QUERY_LOCKER_NAME, {
		variables: { operatorId: operatorID },
	});

	useEffect(() => {
		if (loading) {
			setIsLoading(loading);
		}
	}, [loading]);

	// validation
	const [validation, setValidation] = useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "",
		message: "",
		open: false,
	});

	const EmptyCriteriaHandler = () => {
		// if selectedlockertype is all and blank yung selectedlockername
		if (selectedStatus === null) {
			setNoResultSearch(true);
			setIsTableEmpty(true);
			setnewNoData(false);
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: "Invalid Status",
				message: `Please select a valid campaign status.`,
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
			return false;
		}

		// if (selectedLockerType === "2" && selectedLockerName === "200") {
		// 	console.log("Error: No locker was found");
		// 	setNoResultSearch(true);
		// 	setIsTableEmpty(true);
		// 	setFilteredTableData([]);
		// 	setnewNoData(true);
		// 	return false;
		// }
		// setNoResultSearch(false);
		// setIsTableEmpty(false);
		// setnewNoData(false);
		setNoResultSearch(false);
		setIsTableEmpty(false);
		setnewNoData(false);
		return true;
	};

	// date filter functions
	function getLast30DaysRange() {
		const endDate = new Date();
		const startDate = new Date();
		startDate.setDate(endDate.getDate() - 30);

		console.log({ startDate, endDate });

		return { startDate, endDate };
	}
	function getQuarterToDateRange() {
		const today = new Date();
		const quarterStartMonth = Math.floor(today.getMonth() / 3) * 3;
		const startDate = new Date(today.getFullYear(), quarterStartMonth, 1);
		return { startDate, endDate: today };
	}

	function getYearToDateRange() {
		const today = new Date();
		const startDate = new Date(today.getFullYear(), 0, 1);
		return { startDate, endDate: today };
	}

	function getDateRange(filterValue) {
		switch (filterValue) {
			case "1":
				return getLast30DaysRange();
			case "2":
				return getQuarterToDateRange();
			case "3":
				return getYearToDateRange();
			default:
				return null;
		}
	}

	const buildVariables = () => {
		const updatedVariables = {};

		if (filterVars.operatorId !== "") {
			updatedVariables.operatorId = filterVars.operatorId;
		}
		if (filterVars.status !== "-1") {
			updatedVariables.status = filterVars.status;
		}

		if (filterVars.lockerId !== "-1") {
			updatedVariables.lockerId = filterVars.lockerId;
		}

		if (filterVars.campaignId !== "-1") {
			updatedVariables.campaignId = filterVars.campaignId;
		}

		if (filterVars.startDate !== null) {
			updatedVariables.startDate = new Date(filterVars.startDate).toISOString();
		}

		if (filterVars.endDate !== null) {
			updatedVariables.endDate = new Date(filterVars.endDate).toISOString();
		}

		return updatedVariables;
	};
	// useEffect(() => {
	// 	if (filterButtonClicked) {
	// 		getAllCampaign({
	// 			variables: ({
	// 				status: filterVars.status,
	// 				lockerId:
	// 			}),
	// 		}).then((data) => {
	// 			console.log({ data });
	// 		});
	// 	}
	// });
	const handleSearch = (event, data) => {
		const variable = buildVariables();

		setIsLoading(true);
		setFilterButtonClicked(true);
		// handleSearchResultHeader();
		setFilteredTableData([]);

		const showError = (title, message) => {
			setValidation({
				icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
				title: title,
				message: message,
				open: true,
				actions: (
					<div className="w-full">
						<Button
							onClick={() => setValidation({ open: false })}
							value={"OK"}
							className={"p-2 w-full"}
						/>
					</div>
				),
			});
			setIsTableEmpty(true);
			setnewNoData(true);
			setIsLoading(false);
		};

		if (selectedDateFilterValue === "4") {
			if (customEndDate === "") {
				showError("Invalid Date", "No end date was selected.");
				return;
			}
			if (customStartDate > customEndDate) {
				showError("Invalid Date", "Start date must be before end date.");
				return;
			}
			if (customStartDate === "") {
				showError("Invalid Date", "No start date was selected.");
				return;
			}
		}

		console.log({ variable });
		getAllCampaign({
			variables: {
				filters: {
					operatorId: variable.operatorId,
					campaignId: variable.campaignId,
					status: variable.status,
					lockerId: variable.lockerId,
					startDate: variable.startDate,
					endDate: variable.endDate,
				},
			},
		}).then((data) => {
			console.log({ data });
			setFilteredBehaviorTableData(data.data.allCampaignBehaviors);
		});

		// const boolOne = EmptyCriteriaHandler();
		// if (boolOne) {
		// 	FilterDataTable();
		// }
	};

	console.log({ filteredBehaviorTableData });
	// function FilterDataTable() {
	// 	let totalPartners = 0;
	// 	let totalLockers = 0;

	// 	// Apply filters to the data
	// 	const filterData = (data) => {
	// 		console.log({ data });
	// 		// if (selectedStatus) {
	// 		return data.filter((item) => {
	// 			const campaignStatusName = campaignStatusOptions.find(
	// 				(status) => status.value === item.status
	// 			)?.value;

	// 			const campaignStatusMatch =
	// 				selectedStatus === -1 ||
	// 				selectedStatus === "-1" ||
	// 				campaignStatusName.toString() === selectedStatus;

	// 			const campaignName2 = campaignNameOption.find(
	// 				(name) => name.value === item.campaignBehaviorId
	// 			)?.value;

	// 			const campaignNameMatch =
	// 				selectedCampaignName !== "-1"
	// 					? campaignName2?.toString() === selectedCampaignName
	// 					: true;
	// 			// const campaignNameMatch = selectedCampaignName !== "-1" ?

	// 			const lockerIdMatch =
	// 				selectedLockerName === "-1" || selectedLockerName === "0"
	// 					? true
	// 					: item.lockerId.includes(0) ||
	// 					  item.lockerName.some((locker) => locker.lockerId === "0") ||
	// 					  item.lockerId.includes(parseInt(selectedLockerName)) ||
	// 					  item.lockerName.some(
	// 							(locker) => locker.lockerId === selectedLockerName
	// 					  );

	// 			// const lockerIdMatch =
	// 			// 	selectedLockerName === "-1" || selectedLockerName === "0"
	// 			// 		? item.lockerName.some((locker) => locker.lockerId === 0) ||
	// 			// 		  item.lockerId.includes(0)
	// 			// 		: item.lockerName.some(
	// 			// 				(locker) => locker.lockerId === parseInt(selectedLockerName)
	// 			// 		  );

	// 			console.log({ lockerIdMatch, selectedLockerName });

	// 			const redemptionCodeMatch =
	// 				selectedRedemptionCode !== ""
	// 					? item.redemptionCode
	// 							?.toLowerCase()
	// 							.includes(selectedRedemptionCode)
	// 					: true;

	// 			const rewardTypeMatch =
	// 				selectedRewardType === "-1" ||
	// 				item.rewardTypeId?.toString() === selectedRewardType;

	// 			let startDate, endDate;
	// 			if (
	// 				selectedDateFilterValue === "1" ||
	// 				selectedDateFilterValue === "2" ||
	// 				selectedDateFilterValue === "3"
	// 			) {
	// 				({ startDate, endDate } = getDateRange(selectedDateFilterValue));
	// 			} else if (selectedDateFilterValue === "4") {
	// 				console.log({
	// 					selectedCampaignName,
	// 					customEndDate,
	// 					customStartDate,
	// 					start: item.startDate,
	// 					end: item.endDate,
	// 				});
	// 				startDate = formatDateYYYYMMDD(customStartDate);
	// 				endDate = formatDateYYYYMMDD(customEndDate);
	// 			}

	// 			console.log({ startDate, endDate });

	// 			const isDateRangeMatch =
	// 				startDate && endDate
	// 					? formatDateYYYYMMDD(item.campaignStart) >= startDate &&
	// 					  formatDateYYYYMMDD(item.campaignStart) <= endDate
	// 					: true;

	// 			return (
	// 				campaignStatusMatch &&
	// 				campaignNameMatch &&
	// 				lockerIdMatch &&
	// 				redemptionCodeMatch &&
	// 				rewardTypeMatch &&
	// 				isDateRangeMatch
	// 			);
	// 		});
	// 		// } else {
	// 		// 	return data; // If no selectedStatus, return data as-is
	// 		// }
	// 	};

	// 	// Filter redemptionCodeData and behavioralData
	// 	const filteredRedemptionData = filterData(redemptionCodeData);
	// 	const filteredBehaviorData = filterData(behavioralData);

	// 	const combinedFilteredData = [
	// 		...filteredRedemptionData,
	// 		...filteredBehaviorData,
	// 	];
	// 	const isEmptyTransActions = combinedFilteredData.length === 0;

	// 	// if (isEmptyTransActions) {
	// 	// 	setIsLoading(false);
	// 	// 	setIsTableEmpty(true);
	// 	// 	setnewNoData(true);
	// 	// } else {
	// 	// 	setIsTableEmpty(false);
	// 	// 	setIsLoading(false);
	// 	// }

	// 	setFilteredTableData(filteredRedemptionData);
	// 	setFilteredBehaviorTableData(filteredBehaviorData);
	// }

	// useEffect(() => {
	// 	if (filteredBehaviorTableData && filteredBehaviorTableData.length > 0) {
	// 		let data = [];

	// 		filteredBehaviorTableData.forEach((e) => {
	// 			let obj = { ...e };
	// 			const { startDate, startTime } = formatDateToPHTParts(obj.startDate);
	// 			const { endDate, endTime } = formatDateToPHTParts(obj.endDate);

	// 			obj.lockerName = getLockerName(obj.lockerId);
	// 			// have to parse startDate
	// 			obj.campaignStart = `${formatDate(startDate)} ${formatTime(startTime)}`;
	// 			obj.campaignEnd = `${formatDate(endDate)} ${formatTime(endTime)}`;

	// 			// obj.campaignEnd = formatDate(obj.endDate);
	// 			obj.status = determineCampaignStatus(
	// 				obj,
	// 				obj.redemptions ? obj.redemptions.length : 0
	// 			);

	// 			obj.totalRedemptions = obj.redemptions ? obj.redemptions.length : 0;
	// 			obj.campaignName = obj.campaignTitle;
	// 			obj.perCampaign =
	// 				obj.campaignRedemptionLimit === 0
	// 					? "(0) no limit"
	// 					: obj.campaignRedemptionLimit;

	// 			obj.perPerson =
	// 				obj.userRedemptionLimit === 0
	// 					? "(0) no limit"
	// 					: obj.userRedemptionLimit;

	// 			obj.rewardBehavior = rewardBehaviorTypeDropdown.find(
	// 				(x) => x.value === obj.campaignBehaviorTypeNo
	// 			).name;

	// 			data.push(obj);
	// 		});

	// 		setFilteredBehaviorTableData(data);
	// 		console.log({ MAPPED_DATA: data });
	// 	}
	// }, [filteredBehaviorTableData, lockerName]);
	const header = (type) => (
		<div className="flex items-center justify-between pr-4">
			<>
				{/* <div>
						<Checkbox
							checked={showRewardParams}
							onChange={toggleBehaviorParameter}
							label={
								showRewardParams
									? "Hide Reward Parameter"
									: "Show Reward Parameter"
							}
						/>
					</div> */}
				<div className="pl-2 my-2">
					<div>{`Total Results: ${filteredBehaviorTableData?.length}`}</div>
				</div>
				<div className="my-2 grid ">
					<Button
						disabled={
							accessPermission.behavioralCampaign === 1 ||
							accessPermission.behavioralCampaign === "1"
						}
						value={"Add"}
						className={`bg-primary-primaryYellow justify-self-end px-4 shadow-md p-2  text-black ${
							accessPermission.behavioralCampaign === 1 ||
							accessPermission.behavioralCampaign === "1"
								? "hidden"
								: ""
						}`}
						onClick={() => {
							window.open(
								`${process.env.REACT_APP_BASE_ENVIRONMENT}mbox-behavioral-campaigns/add`
							);
						}}
					></Button>
				</div>
			</>
		</div>
	);

	const headerGroup = (type) => (
		<ColumnGroup>
			<Row>
				<Column
					header="Status"
					sortable={true}
					headerStyle={{ backgroundColor: "#FECD08" }}
					alignHeader={"center"}
					field="status"
					colSpan={1}
					rowSpan={2}
					// sortable={true}
				/>
				<Column
					header="Campaign Date"
					alignHeader={"center"}
					colSpan={2}
					rowSpan={1}
					headerStyle={{ backgroundColor: "#FECD08" }}
				/>
				<Column
					header="Campaign Name"
					alignHeader={"center"}
					colSpan={1}
					rowSpan={2}
					headerStyle={{ backgroundColor: "#FECD08" }}
				/>
				<Column
					header="Locker Name"
					alignHeader={"center"}
					colSpan={1}
					rowSpan={2}
					headerStyle={{ backgroundColor: "#FECD08" }}
				/>
				{showRedemptionCodeColumn && type === "redemptionCode" && (
					<Column
						header="Redemption Code"
						alignHeader={"center"}
						colSpan={1}
						rowSpan={2}
						headerStyle={{ backgroundColor: "#FECD08" }}
					/>
				)}

				<Column
					header="Redemption Limit"
					alignHeader={"center"}
					colSpan={2}
					rowSpan={1}
					headerStyle={{ backgroundColor: "#FECD08" }}
				/>

				{type === "redemptionCode" && (
					<Column
						header="Reward Type"
						alignHeader={"center"}
						colSpan={1}
						rowSpan={2}
						headerStyle={{ backgroundColor: "#FECD08" }}
					/>
				)}

				{type === "behavioral" && (
					<Column
						header="Reward Behavior"
						alignHeader={"center"}
						sortable={true}
						field="rewardBehavior"
						colSpan={1}
						rowSpan={2}
						headerStyle={{ backgroundColor: "#FECD08" }}
					/>
				)}

				{/* {showRewardParams && type === "behavioral" && (
					<Column
						header="Reward Parameter"
						alignHeader={"center"}
						colSpan={1}
						rowSpan={2}
						headerStyle={{ backgroundColor: "#FECD08" }}
					/>
				)} */}

				<Column
					header="Total Redemptions"
					alignHeader={"center"}
					colSpan={1}
					rowSpan={2}
					field="totalRedemptions"
					sortable={true}
					headerStyle={{ backgroundColor: "#FECD08" }}
				/>
				<Column
					header=""
					alignHeader={"center"}
					// hidden={`${
					// 	accessPermission.behavioralCampaign === 1 ||
					// 	accessPermission.behavioralCampaign === "1"
					// 		? "hidden"
					// 		: ""
					// }`}
					field="action"
					colSpan={1}
					rowSpan={2}
					headerStyle={{
						backgroundColor: "#FECD08",
					}}
				/>
			</Row>
			<Row>
				<Column
					header="Start Date"
					field="campaignStart"
					sortable={true}
					headerStyle={{ backgroundColor: "#FECD08" }}
					headerClassName="text-center"
					alignHeader={"center"}
				/>
				<Column
					header="End Date"
					field="campaignEnd"
					sortable={true}
					headerClassName="text-center"
					headerStyle={{ backgroundColor: "#FECD08" }}
					alignHeader={"center"}
				/>

				<Column
					header="Per Campaign "
					field="campaign"
					sortable={true}
					headerClassName="text-center"
					headerStyle={{ backgroundColor: "#FECD08" }}
					alignHeader={"center"}
				/>
				<Column
					header="Per Person"
					field="person"
					sortable={true}
					headerClassName="text-center"
					headerStyle={{ backgroundColor: "#FECD08" }}
					alignHeader={"center"}
				/>
			</Row>
		</ColumnGroup>
	);

	// const formatDate = (inputDate) => {
	// 	if (inputDate == null) {
	// 		return "";
	// 	}

	// 	// Remove the timezone offset from the inputDate string
	// 	const adjustedDateString = inputDate.replace(/([+-]\d{2}:\d{2})$/, "");

	// 	// Parse the adjusted date string
	// 	const date = new Date(adjustedDateString);

	// 	// Format the date to "Jul 25, 2024, 1:08 PM"
	// 	const options = {
	// 		year: "numeric",
	// 		month: "short",
	// 		day: "numeric",
	// 		hour: "numeric",
	// 		minute: "numeric",
	// 		hour12: true,
	// 	};

	// 	return date.toLocaleString("en-US", options);
	// };

	// console.log({ lockerName });

	const getLockerName = (lockerIds) => {
		console.log({ received: lockerIds, lockerName });
		if (lockerName) {
			let lockerIdToNameMap = lockerName.reduce((acc, locker) => {
				acc[locker.value] = locker.name;
				return acc;
			}, {});

			if (
				lockerIds.length === 1 &&
				(lockerIds[0] === "0" || lockerIds[0] === 0)
			) {
				return [{ lockerId: "0", lockerName: "All Lockers" }];
			} else {
				return lockerIds.map((id) => ({
					lockerId: id,
					lockerName: lockerIdToNameMap[id],
				}));
			}
		}
		return [];
	};

	const determineCampaignStatus = (item, totalRedemptions) => {
		// console.log({ item, totalRedemptions });

		const campaignEndDate = new Date(item.campaignEnd);

		const today = new Date();
		// console.log({ campaignEndDate, today });

		if (today > campaignEndDate) {
			return 2; // Assuming value 2 is for "Expired"
		}
		if (parseInt(totalRedemptions) >= parseInt(item.perCampaign)) {
			return 3; // Assuming value 3 is for "Fully Redeemed"
		} else {
			return 1; // Assuming value 1 is for "Active"
		}
	};

	const handleRowClick = (rowData, purpose) => {
		const redemptionDetails = Array.isArray(rowData.redemptions)
			? rowData.redemptions
			: [];

		console.log({ rowData });
		if (purpose === "redemptionDetails") {
			setSelectedRowData(redemptionDetails);

			setShowRedemptionDetail(true);
		} else {
			setSelectedRowData(rowData);
		}

		// console.log({ rowData });
	};

	useEffect(() => {
		const fetchOperatorID = () => {
			let opIDLocal = localStorage.getItem("user");
			let opIDLocal2 = JSON.parse(opIDLocal);
			if (opIDLocal2) {
				setOperatorID(opIDLocal2.operator_id);
			}
		};

		fetchOperatorID();
	}, []);

	useEffect(() => {
		if (allCampaigns && allCampaigns.data) {
			let behaviorData = [];

			// allCampaigns.data.allCampaignBehaviors.forEach((e) => {
			// 	let obj = { ...e };
			// 	const { startDate, startTime } = formatDateToPHTParts(obj.startDate);
			// 	const { endDate, endTime } = formatDateToPHTParts(obj.endDate);
			// 	console.log({ endDate, endTime });

			// 	obj.lockerName = getLockerName(obj.lockerId);
			// 	// have to parse startDate
			// 	obj.campaignStart = `${formatDate(startDate)} ${formatTime(startTime)}`;
			// 	obj.campaignEnd = `${formatDate(endDate)} ${formatTime(endTime)}`;

			// 	// obj.campaignEnd = formatDate(obj.endDate);
			// 	obj.status = determineCampaignStatus(
			// 		obj,
			// 		obj.redemptions ? obj.redemptions.length : 0
			// 	);

			// 	obj.totalRedemptions = obj.redemptions ? obj.redemptions.length : 0;
			// 	obj.campaignName = obj.campaignTitle;
			// 	obj.perCampaign =
			// 		obj.campaignRedemptionLimit === 0
			// 			? "(0) no limit"
			// 			: obj.campaignRedemptionLimit;

			// 	obj.perPerson =
			// 		obj.userRedemptionLimit === 0
			// 			? "(0) no limit"
			// 			: obj.userRedemptionLimit;

			// 	obj.rewardBehavior = rewardBehaviorTypeDropdown.find(
			// 		(x) => x.value === obj.campaignBehaviorTypeNo
			// 	).name;

			// 	behaviorData.push(obj);
			// });
			setBehavioralData(allCampaigns.data.allCampaignBehaviors);
			setIsLoading(false);
		} else {
			setIsLoading(true);
		}
	}, [allCampaigns, lockerName]);

	useEffect(() => {
		if (allLockerNames && allLockerNames.lockers) {
			let tempData = [];
			allLockerNames.lockers.forEach((element, index) => {
				tempData.push({
					value: element.lockerId,
					name: element.lockerName,
				});
			});
			setLockerName(tempData);
		}
	}, [allLockerNames]);
	useEffect(() => {
		if (behavioralData && filterVars.status !== null) {
			const behavioralCampaigns = behavioralData;

			let filteredCampaigns;

			if (parseInt(filterVars.status) === 1) {
				// If status is 1, return only active (not expired) campaigns
				filteredCampaigns = behavioralCampaigns.filter(
					(campaign) => campaign.isExpired === false
				);
			} else if (parseInt(filterVars.status) === 2) {
				filteredCampaigns = behavioralCampaigns.filter(
					(campaign) => campaign.isExpired === true
				);
			} else {
				// Otherwise, filter by campaign status
				filteredCampaigns = behavioralCampaigns.filter(
					(campaign) =>
						parseInt(campaign.campaignStatus) === parseInt(filterVars.status)
				);
			}

			console.log({ filteredCampaigns, behavioralCampaigns });

			const campaignNames = filteredCampaigns.map((campaign) => ({
				name: campaign.campaignTitle,
				value: campaign.campaignBehaviorId,
			}));

			const allCampaigns = behavioralCampaigns.map((campaign) => ({
				name: campaign.campaignTitle,
				value: campaign.campaignBehaviorId,
			}));

			if (filterVars.status === -1 || filterVars.status === "-1") {
				setCampaignNameOptions(allCampaigns);
			} else {
				setCampaignNameOptions(campaignNames);
			}
		}
	}, [behavioralData, filterVars.status]);

	console.log({ campaignNameOption });
	
	useEffect(() => {
		if (selectedRowData && selectedRowData.campaignBehaviorId) {
			let campaignId = parseInt(selectedRowData.campaignBehaviorId);
			window.open(
				`${process.env.REACT_APP_BASE_ENVIRONMENT}mbox-behavioral-campaigns/edit-behavioral/${campaignId}`,
				"_blank"
			);
		}
	}, [selectedRowData]);

	const handleFilterVariableChange = (e, field) => {
		const value = e.target.value;

		if (field === "dateFilterOption") {
			if (value !== "4") {
				const { startDate, endDate } = getDateRange(value);

				setFilterVars({
					...filterVars,
					[field]: value,
					startDate: startDate,
					endDate: endDate,
				});
			} else {
				setFilterVars({
					...filterVars,
					[field]: value,
					startDate: filterVars.startDate,
					endDate: filterVars.endDate,
				});
			}
		} else {
			setFilterVars({
				...filterVars,
				[field]: value,
			});
		}
	};

	console.log({ filterVars });
	return (
		<>
			<ContentContainer containerTitle={"Behavioral Campaigns"}>
				<div>
					<h2 className={"font-bold"}>Campaign:</h2>
					<div className={"grid grid-cols-2 w-1/2 gap-y-2 indent-3 pt-2"}>
						<div>Campaign Status:</div>
						<Select
							items={campaignStatusOptions}
							value={filterVars.status}
							defaultOption={{ value: -1, name: "-- All --" }}
							onChange={(e) => {
								// setSelectedStatus(e.target.value);
								handleFilterVariableChange(e, "status");
							}}
						/>

						<p>Campaign Name:</p>
						<Select
							// disabled={selectedStatus === -1}
							items={campaignNameOption}
							value={filterVars.campaignId}
							defaultOption={{ value: "-1", name: "-- All --" }}
							onChange={(e) => {
								handleFilterVariableChange(e, "campaignId");
							}}
						/>

						<p>Locker Name:</p>

						<Select
							items={lockerName}
							defaultOption={{ value: "-1", name: "-- All --" }}
							value={filterVars.lockerId}
							onChange={(e) => {
								handleFilterVariableChange(e, "lockerId");
							}}
						/>

						{/* <p>Reward Type</p>
						<Select
							// value={rewardType}
							value={selectedRewardType}
							items={rewardType}
							defaultOption={{ value: "-1", name: "-- All --" }}
							onChange={(e) => {
								setSelectedRewardType(e.target.value);
							}}
							className="w-full"
						/> */}

						<p>Date Filter:</p>
						<Select
							items={dateFilters}
							value={filterVars.dateFilterOption}
							defaultOption={{ value: "-1", name: "--- All ---" }}
							onChange={(e) => {
								handleFilterVariableChange(e, "dateFilterOption");

								// setSelectedDateFilterValue(e.target.value);
							}}
						/>
					</div>

					<div className="grid grid-cols-7 w-[58%] pt-[8px]">
						<div></div>
						{filterVars.dateFilterOption === "4" && (
							<div className="col-span-5">
								<PrimereactDateRange
									startDate={filterVars.startDate}
									endDate={filterVars.endDate}
									maxEnd={null}
									readOnlyInput={true}
									max={new Date()}
									min={new Date("2021-01-01")}
									onChange={(event) => {
										if (event.target.name === "signupDateFrom") {
											// setCustomStartDate(event.target.value);

											handleFilterVariableChange(event, "startDate");
										} else {
											handleFilterVariableChange(event, "endDate");
										}
									}}
								/>
							</div>
						)}
					</div>
					<div className="flex w-[76%]">
						<div></div>
						<u
							className="flex hover:text-blue-500 cursor-pointer mt-4 ml-auto w-min"
							onClick={() => {
								setFilterVars({
									status: "-1",
									lockerId: "-1",
									campaignId: "-1",
									dateFilterOption: "-1",
									startDate: null,
									endDate: null,
								});
							}}
						>
							<i className="fas fa-undo my-auto"></i>
							<p className="ml-1">Reset</p>
						</u>
					</div>
					<Button
						value={"Search"}
						// disabled={behavioralData.length < 0}
						onClick={handleSearch}
						className={"w-40 h-8 m-5"}
					/>
				</div>
				{/* !isTableEmpty && filterButtonClicked */}
				{filterButtonClicked && (
					<Card>
						<DataTable
							showGridlines
							paginator
							rows={10}
							removableSort
							value={filteredBehaviorTableData}
							stripedRows
							// header={header}
							header={header("behavioral")}
							headerColumnGroup={headerGroup("behavioral")}
							paginatorTemplate={paginatorTemplate}
						>
							<Column
								key="isExpired"
								field="isExpired"
								className="text-center"
								body={(rowData) => {
									let statusColor = "";
									let statusName = "";

									if (rowData.isExpired === false) {
										statusColor = "bg-green-400";
										statusName = "Active";
									} else if (rowData.isExpired === true) {
										statusColor = "bg-gray-300";
										statusName = "Expired";
									} else {
										statusColor = "bg-orange-400";
										statusName = "Redeemed";
									}
									return (
										<Badge
											className={`h-auto rounded-[3px] ${statusColor} text-secondary-purpleGray shadow-sm`}
											value={statusName}
										></Badge>
									);
								}}
							/>

							<Column
								key="startDate"
								field="startDate"
								className="text-center"
								body={(rowData) => {
									const { startDate, startTime } = formatDateToPHTParts(
										rowData.startDate
									);
									return (
										<div>
											{`${formatDate(startDate)} ${formatTime(startTime)}`}
										</div>
									);
								}}
							/>

							<Column
								key="endDate"
								field="endDate"
								className="text-center"
								body={(rowData) => {
									const { endDate, endTime } = formatDateToPHTParts(
										rowData.endDate
									);
									return (
										<div>{`${formatDate(endDate)} ${formatTime(endTime)}`}</div>
									);
								}}
							/>

							<Column
								key="campaignTitle"
								field="campaignTitle"
								className="text-center"
							/>

							<Column
								key="lockerId"
								field="lockerId"
								className="text-center"
								body={(rowData) => {
									const lockerNames = getLockerName(rowData.lockerId);
									return (
										<div>
											{lockerNames.map((locker, index) => (
												<div key={index}>{locker.lockerName}</div>
											))}
										</div>
									);
								}}
							/>

							<Column
								key="campaignRedemptionLimit"
								field="campaignRedemptionLimit"
								className="text-center"
								body={(rowData) =>
									rowData.campaignRedemptionLimit === 0
										? "(0) no limit"
										: rowData.campaignRedemptionLimit
								}
							/>

							<Column
								key="userRedemptionLimit"
								field="userRedemptionLimit"
								className="text-center"
								body={(rowData) =>
									rowData.userRedemptionLimit === 0
										? "(0) no limit"
										: rowData.userRedemptionLimit
								}
							/>
							<Column
								key="rewardBehavior"
								field="rewardBehavior"
								className="text-center"
								sortable
								body={(rowData) => {
									const rewardBehavior = rewardBehaviorTypeDropdown.find(
										(x) => x.value === rowData.campaignBehaviorTypeNo
									)?.name;

									return <div>{rewardBehavior}</div>;
									// <div>{rewa}</div>
								}}
							/>

							<Column
								key="totalRedemptions"
								field="totalRedemptions"
								className="text-center hover:underline hover:text-blue-400 hover:cursor-pointer"
								body={(rowData) => (
									<div
										onClick={() => {
											// console.log("OPEN DIALOG");
											handleRowClick(rowData, "redemptionDetails");
										}}
									>
										{rowData.totalRedemptions ? rowData.totalRedemptions : 0}
									</div>
								)}
							/>
							<Column
								key="action"
								field="action"
								className={``}
								// headerStyle={{ backgroundColor: "#FECD08" }}
								body={(rowData) => (
									<IconButton
										type="button"
										icon={`${
											accessPermission.behavioralCampaign === 1 ||
											accessPermission.behavioralCampaign === "1"
												? "pi pi-eye"
												: "pi pi-pencil"
										}`}
										className="bg-primary-primaryYellow text-black border-0 "
										onClick={() => handleRowClick(rowData, "edit")}
										// disabled={isLoading || loading}
									/>
								)}
							/>
						</DataTable>
					</Card>
				)}

				{/* go back here if u wanna suffer :> */}
				{/* <BehavioralCampaignTable
					filterButtonClicked={filterButtonClicked}
					isLoading={isLoading}
					filteredBehaviorTableData={filteredBehaviorTableData}
					accessPermission={accessPermission}
					getLockerName={getLockerName}
					handleRowClick={handleRowClick}
					lockerName={lockerName}
				/> */}
				<Dialog
					visible={showRedemptionDetail}
					header="Redemption Details"
					className="min-w-[450px]"
					onHide={() => setShowRedemptionDetail(false)}
					draggable={false}
					resizable={false}
				>
					<Card className="bg-primary-primaryYellowLight">
						<div className="font-semibold py-2">
							Total Redemptions: {selectedRowData.length}
						</div>
						<DataTable
							value={selectedRowData}
							showGridlines
							stripedRows
							paginator
							multiple
							removableSort
							sortMode="multiple"
							rows={10}
							rowHover={true}
							emptyMessage="No redemption details found"
							paginatorTemplate={paginatorTemplate}
						>
							<Column
								headerClassName="bg-primary-primaryYellow text-center"
								key="transactionId"
								field="transactionId"
								alignHeader={"center"}
								header="Transaction ID"
								sortable
								className="text-center"
							/>
							<Column
								headerClassName="bg-primary-primaryYellow text-center"
								key={"userName"}
								field="userName"
								alignHeader={"center"}
								header="User Name"
								sortable
								className="text-center"
							/>
							<Column
								headerClassName="bg-primary-primaryYellow text-center"
								key={"userId"}
								field="userId"
								alignHeader={"center"}
								header="Mobile Number"
								sortable
								className="text-center"
							/>
						</DataTable>
					</Card>
				</Dialog>

				<Modal
					icon={validation.icon}
					title={validation.title}
					message={validation.message}
					open={validation.open}
					actions={validation.actions}
				/>
			</ContentContainer>
		</>
	);
};

export default BehavioralCampaign;
